// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3UkD3","content":"ManualTimeModal_content__2hL9W"};